import { useId, useState } from "react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/hooks/useLanguage";
import { conceptIntroduction } from "@/lib/anayaConcept";

export function AnayaConceptDescription({ description, excerpt }: { description: string; excerpt: string }) {
  const [expanded, setExpanded] = useState(false);
  const id = useId();
  const { t } = useLanguage();
  const intro = conceptIntroduction(description, excerpt);
  if (!description) return null;
  const canExpand = intro.trim() !== description.trim();
  return (
    <div className="mb-8 text-lg leading-relaxed lg:min-h-[10lh]">
      <p id={id} className="text-muted-foreground whitespace-pre-line break-words [overflow-wrap:anywhere]">
        {expanded ? description : intro}
      </p>
      {canExpand && (
        <Button
          type="button"
          variant="link"
          className="mt-1 min-h-11 h-auto px-0 text-base tracking-normal"
          aria-expanded={expanded}
          aria-controls={id}
          onClick={() => setExpanded(value => !value)}
        >
          {t(expanded ? "btn.readLess" : "btn.readMore")}
        </Button>
      )}
    </div>
  );
}